



















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    directives: {
        focus: {
            inserted: (el) => {
                el.focus();
            },
        },
    },
})
export default class Input extends Vue {
    @Prop(String) public placeholder?: string;
    @Prop(String) public value?: string;
    @Prop(Boolean) public always?: boolean;

    public edit: boolean = false;
    public localValue: string = this.value || '';

    @Watch('value')
    public onValueChanged(value?: string, oldValue?: string) {
        this.localValue = value || '';
    }

    public onInput(event: any) {
        if (this.always) {
            this.localValue = event.target.value;
            this.$emit('input', this.localValue);
        }
    }

    public onEnter(event: any) {
        if (!this.always) {
            this.localValue = event.target.value;
            this.edit = false;
            this.$emit('input', this.localValue);
        }
    }
}
